import React from 'react';
import { useSelector } from 'react-redux';
import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';
import Sorter from 'components/admin/forms/sorter';
import { apiPatch } from 'services';

export const SortCompetencies = ({ show, close, refresh, competencies, noFilter, areaName }) => {
    const user = useSelector(state => state.user.user);
    const [saving, setSaving] = React.useState(false);
    const [filtered, setFiltered] = React.useState([]);
    const [area, setArea] = React.useState(0);
    const [areas, setAreas] = React.useState([]);
    const [order, setOrder] = React.useState([]);

    React.useEffect(() => {
        if (noFilter) {
            setFiltered(competencies.filter(c => c.active).map((x, i) => ({ ...x, sequence: i + 1 })));
        } else {
            const temp = competencies
                .reduce((a, c) => {
                    return a.some(a => a.id === c.area_Id) ? a : a.concat({ id: c.area_Id, name: c.area });
                }, [])
                .sort((a, b) => (a.name > b.name ? 1 : -1));

            setAreas(temp);
            setArea(temp[0].id);
        }
    }, [competencies, noFilter]);

    React.useEffect(() => {
        !noFilter &&
            setFiltered(competencies.filter(c => c.area_Id === area && c.active).map((x, i) => ({ ...x, sequence: i + 1 })));
    }, [competencies, area, noFilter]);

    const onSave = () => {
        const promises = [];

        order.forEach(c => {
            promises.push(apiPatch('competency', c, user.guid));
        });

        Promise.all(promises).then(() => {
            refresh();
            close();
        });
    };

    const footer = (
        <div className="pull-right">
            <SaveButton saving={saving} setSaving={setSaving} className="btn btn-success" onClick={() => onSave()}>
                {SystemText('Admin/Competency/Sort/Buttons/Save')}
            </SaveButton>
            <button className="btn" onClick={() => close()}>
                {SystemText('Admin/Competency/Sort/Buttons/Close')}
            </button>
        </div>
    );

    return (
        <Modal
            title={`${SystemText('Admin/Competency/Sort/Modal/Title')}${areaName ? ` - ${areaName}` : ''}`}
            show={show}
            close={close}
            footer={footer}
        >
            {!noFilter && (
                <Forms.Select
                    label={SystemText('Admin/Competency/Sort/Area/Label')}
                    help={SystemText('Admin/Competency/Sort/Area/Help')}
                    data={areas}
                    value={area}
                    onChange={setArea}
                    mandatory
                />
            )}
            <Sorter
                label={SystemText('Admin/Competency/Sort/Sorter/Label')}
                help={SystemText('Admin/Competency/Sort/Sorter/Help')}
                options={filtered}
                onChange={options => setOrder(options)}
            />
        </Modal>
    );
};

export default SortCompetencies;
